import {SvgIcon} from '@mui/material';
export function MockIcon() {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.9168 9.66667C12.9168 11.2775 11.611 12.5833 10.0002 12.5833C8.38933 12.5833 7.0835 11.2775 7.0835 9.66667C7.0835 8.05584 8.38933 6.75 10.0002 6.75C11.611 6.75 12.9168 8.05584 12.9168 9.66667Z'
        stroke='#2D2D2D'
        strokeWidth='1.25'
      />
      <path
        d='M10 2.1665C14.0588 2.1665 17.5 5.52732 17.5 9.60464C17.5 13.7469 14.0028 16.6538 10.7725 18.6304C10.5371 18.7633 10.2709 18.8332 10 18.8332C9.72913 18.8332 9.46291 18.7633 9.2275 18.6304C6.00325 16.6345 2.5 13.7612 2.5 9.60464C2.5 5.52732 5.9412 2.1665 10 2.1665Z'
        stroke='#2D2D2D'
        strokeWidth='1.25'
      />
    </svg>
  );
}

export const AllFiltersIcon = () => (
  <SvgIcon>
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.5 5.8335H5'
        stroke='#2D2D2D'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.5 14.167H7.5'
        stroke='#2D2D2D'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15 14.167L17.5 14.167'
        stroke='#2D2D2D'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5 5.8335L17.5 5.8335'
        stroke='#2D2D2D'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 5.8335C5 5.05693 5 4.66864 5.12687 4.36236C5.29602 3.95398 5.62048 3.62952 6.02886 3.46036C6.33515 3.3335 6.72343 3.3335 7.5 3.3335C8.27657 3.3335 8.66485 3.3335 8.97114 3.46036C9.37952 3.62952 9.70398 3.95398 9.87313 4.36236C10 4.66864 10 5.05693 10 5.8335C10 6.61007 10 6.99835 9.87313 7.30464C9.70398 7.71302 9.37952 8.03747 8.97114 8.20663C8.66485 8.3335 8.27657 8.3335 7.5 8.3335C6.72343 8.3335 6.33515 8.3335 6.02886 8.20663C5.62048 8.03747 5.29602 7.71302 5.12687 7.30464C5 6.99835 5 6.61007 5 5.8335Z'
        stroke='#2D2D2D'
        strokeWidth='1.25'
      />
      <path
        d='M10 14.167C10 13.3904 10 13.0021 10.1269 12.6959C10.296 12.2875 10.6205 11.963 11.0289 11.7939C11.3351 11.667 11.7234 11.667 12.5 11.667C13.2766 11.667 13.6649 11.667 13.9711 11.7939C14.3795 11.963 14.704 12.2875 14.8731 12.6959C15 13.0021 15 13.3904 15 14.167C15 14.9436 15 15.3318 14.8731 15.6381C14.704 16.0465 14.3795 16.371 13.9711 16.5401C13.6649 16.667 13.2766 16.667 12.5 16.667C11.7234 16.667 11.3351 16.667 11.0289 16.5401C10.6205 16.371 10.296 16.0465 10.1269 15.6381C10 15.3318 10 14.9436 10 14.167Z'
        stroke='#2D2D2D'
        strokeWidth='1.25'
      />
    </svg>
  </SvgIcon>
);

export const SearchIcon = () => (
  <SvgIcon>
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_2548_8570)'>
        <path
          d='M14.5835 14.583L18.3335 18.333'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.667 9.1665C16.667 5.02437 13.3091 1.6665 9.16699 1.6665C5.02486 1.6665 1.66699 5.02437 1.66699 9.1665C1.66699 13.3086 5.02486 16.6665 9.16699 16.6665C13.3091 16.6665 16.667 13.3086 16.667 9.1665Z'
          stroke='white'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2548_8570'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
